export type OutdoorCommonAreaTypesProps = {
  hasDeck: boolean;
  hasGarden: boolean;
  hasGazebo: boolean;
  hasLawn: boolean;
  hasPatio: boolean;
  hasPicnicArea: boolean;
  hasPlayground: boolean;
  hasRooftopDeck: boolean;
  hasTrail: boolean;
  hasWaterFeature: boolean;
};

const OutdoorCommonAreaTypes = ({
  hasDeck = false,
  hasGarden = false,
  hasGazebo = false,
  hasLawn = false,
  hasPatio = false,
  hasPicnicArea = false,
  hasPlayground = false,
  hasRooftopDeck = false,
  hasTrail = false,
  hasWaterFeature = false,
}: Partial<OutdoorCommonAreaTypesProps> = {}): OutdoorCommonAreaTypesProps => ({
  hasDeck: Boolean(hasDeck),
  hasGarden: Boolean(hasGarden),
  hasGazebo: Boolean(hasGazebo),
  hasLawn: Boolean(hasLawn),
  hasPatio: Boolean(hasPatio),
  hasPicnicArea: Boolean(hasPicnicArea),
  hasPlayground: Boolean(hasPlayground),
  hasRooftopDeck: Boolean(hasRooftopDeck),
  hasTrail: Boolean(hasTrail),
  hasWaterFeature: Boolean(hasWaterFeature),
});

export default OutdoorCommonAreaTypes;
